<template>
    <b-overlay :show="busy" rounded="sm">
        <b-card class="standardpage reports invoices border-none">
            <!-- {{ id }}
        {{ disabled }} -->
            <!-- {{ remittanceno }} -->
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-wpforms text-info mr-1"></i>
                                        {{ selection[0].invoiceno }}
                                        <b-badge id="selection" variant="primary" class="edit_tab">
                                            {{ selection.length }}</b-badge>
                                        <b-tooltip target="selection" placement="bottom">{{ selection.length }} entry(s)
                                            selected</b-tooltip>
                                    </div>
                                </template>

                                <b-row class="mt-3 mb-3 mx-n3">
                                    <b-col cols="auto" class="mr-auto"> <b-list-group horizontal="md" size="sm">
                                            <b-list-group-item variant="dark"><span class="list-label">To:
                                                    {{ slac }}</span> {{ to }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Your
                                                    Ref/PO:</span>{{ yourref }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Invoice
                                                    No:</span>{{ invoiceno }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Date:</span>{{
                                                $moment.unix(lines.items[0].date_at *
                                                    0.001).utc(true).format("DD-MMM-YYYY")
                                            }}</b-list-group-item>

                                        </b-list-group></b-col>
                                    <b-col cols="auto"> <b-list-group horizontal="md" size="sm">
                                            <b-list-group-item variant="dark-primary"><span
                                                    class="list-label">Amount:</span>{{ paid | currency("")
                                                    }}</b-list-group-item>
                                            <b-list-group-item variant="dark-primary"><span
                                                    class="list-label">Due:</span>{{
                                                        due | currency("")
                                                    }}</b-list-group-item>
                                        </b-list-group></b-col>
                                    <div>

                                    </div>
                                </b-row>


                                <p class="mt-2">
                                    <b-tabs>
                                        <b-tab>
                                            <template #title>
                                                <div class="badgecontainer pr-1 mr-1 w-60px">
                                                    <i :class="lines.icon" class="ml-1"></i> Lines
                                                    <b-badge variant="white" class="edit_tab">
                                                    </b-badge>

                                                </div>
                                            </template>
                                            <b-row>
                                                <b-col>
                                                    <d-table classdivtable="availtable datatable nested"
                                                        refid="segments" :icon="lines.icon" :selectmode="'single'"
                                                        :busy="lines.busy" :tools="lines.tools" :badges="lines.badges"
                                                        :fields="lines.fields" :items="lines.items" :page="lines.page"
                                                        :showpages="false" @load="lines_load" @click="lines_click"
                                                        @select="lines_select" @totalled="lines_total">
                                                    </d-table>
                                                </b-col>
                                            </b-row>

                                            <b-tabs v-if="lines.item.line" class="gridtabs mt-2">


                                                <b-tab>
                                                    <!-- <template #title>
                                                        <i class="fa fa-gbp text-primary mr-1"></i>
                                                        <span class="text-warning">&lt;{{ selection.length == 0 ? "new" :
                                                            "edit" }}&gt;</span>
                                                    </template> -->

                                                    <template #title>
                                                        <span class="text-primary">{{lines.items.map(o =>
                                                            o.line).indexOf(lines.item.line) + 1
                                                        }}.</span>
                                                        <i :class="'fa fa fa-arrows-h text-info'"
                                                            class="text-primary ml-1 mr-1"></i>
                                                        <span class="text-warning">&lt;{{ selection.length == 0 ? "new"
                                                            : "edit" }}&gt;</span>&nbsp;


                                                    </template>

                                                    <!-- {{ lines.item }} -->
                                                    <p class="py-3 px-0">

                                                        <b-row>
                                                            <b-col cols="12" sm="4" md="3">
                                                                <b-form-group label-cols="12" label="Invoice Date"
                                                                    label-size="sm">
                                                                    <b-input-group>
                                                                        <daterangepicker style="width:auto !important"
                                                                            size="sm" ref="date"
                                                                            v-model="mapper_date_at" :opens="'right'"
                                                                            :single-date-picker="'single'" :locale-data="{
                                                                                direction: 'ltr',
                                                                                format: 'dd/mm/yy HH:MM',
                                                                                daysOfWeek: [
                                                                                    'Sun',
                                                                                    'Mon',
                                                                                    'Tue',
                                                                                    'Wed',
                                                                                    'Thu',
                                                                                    'Fri',
                                                                                    'Sat',
                                                                                ],
                                                                                monthNames: [
                                                                                    'January',
                                                                                    'February',
                                                                                    'March',
                                                                                    'April',
                                                                                    'May',
                                                                                    'June',
                                                                                    'July',
                                                                                    'August',
                                                                                    'September',
                                                                                    'October',
                                                                                    'November',
                                                                                    'December',
                                                                                ],
                                                                                firstDay: 1,
                                                                            }" :ranges="false" :showDropdowns="true"
                                                                            :linkedCalendars="true" :timePicker="true"
                                                                            :timePicker24Hour="true"
                                                                            :time-picker-increment="1">
                                                                        </daterangepicker>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="mapper_date_at = { startDate: null, endDate: null }"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>

                                                                </b-form-group>
                                                            </b-col>



                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label-cols="12" label="Supplier B/L"
                                                                    label-size="sm">
                                                                    <treeselect placeholder="Select blac..."
                                                                        searchPromptText="Type at least 3 chars..."
                                                                        v-model="lines.item.blac" :clearable="true"
                                                                        :async="true"
                                                                        :load-options="treeselect_loadBLAC"
                                                                        :show-count="true"
                                                                        :flatten-search-results="true"
                                                                        :disable-branch-nodes="true" :matchKeys="['id']"
                                                                        search-nested :disabled="readonly">
                                                                        <div slot="value-label" slot-scope="{ node }">
                                                                            {{ node.raw.id }}
                                                                        </div>
                                                                    </treeselect>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Supplier Type" label-for="bltype"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.bltype"
                                                                            placeholder="Supplier Type" size="sm" trim
                                                                            :disabled=true></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.bltype = ''"
                                                                                :disabled=true>
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>



                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label-cols="12" label="InvoiceNo"
                                                                    label-size="sm">
                                                                    <b-input-group>
                                                                        <b-form-input v-model="lines.item.invoiceno"
                                                                            :debounce="lines.debounce"
                                                                            placeholder="InvoiceNo"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                :disabled="readonly"
                                                                                @click="lines.item.invoiceno = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                        </b-row>


                                                        <b-row>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label-cols="12" label="Ticket No/Ref"
                                                                    label-size="sm">
                                                                    <b-input-group>
                                                                        <b-form-input v-model="lines.item.ticketno"
                                                                            :debounce="lines.debounce"
                                                                            placeholder="Ticket No"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                :disabled="readonly"
                                                                                @click="lines.item.ticketno = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                             <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label-cols="12" label="Ticket Type"
                                                                    label-size="sm">
                                                                    <b-input-group>
                                                                        <b-form-input v-model="lines.item.tickettype"
                                                                            :debounce="lines.debounce"
                                                                            placeholder="Ticket Type"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                :disabled="true"
                                                                                @click="lines.item.tickettype = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label-cols="12"
                                                                    label="Description / Passenger" label-size="sm">
                                                                    <b-input-group>
                                                                        <b-form-input v-model="lines.item.passenger"
                                                                            :debounce="lines.debounce"
                                                                            placeholder="Description / Passenger"
                                                                            :disabled="false"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                :disabled="!lines.item.passenger"
                                                                                @click="lines.item.passenger = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Airline / Supplier"
                                                                    label-for="airline" label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.airline"
                                                                            placeholder="Airline / Supplier" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.airline = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Your Ref / PO" label-for="yourref"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.yourref"
                                                                            placeholder="Your Ref / PO" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.yourref = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label-cols="12" label="Client SL A/C"
                                                                    label-size="sm">
                                                                    <treeselect placeholder="Select slac..."
                                                                        searchPromptText="Type at least 3 chars..."
                                                                        v-model="lines.item.slac" :clearable="true"
                                                                        :async="true"
                                                                        :load-options="treeselect_loadSLAC"
                                                                        :show-count="true"
                                                                        :flatten-search-results="true"
                                                                        :disable-branch-nodes="true" :matchKeys="['id']"
                                                                        search-nested :disabled="readonly">
                                                                        <div slot="value-label" slot-scope="{ node }">
                                                                            {{ node.raw.id }}
                                                                        </div>
                                                                    </treeselect>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label-cols="12" label="Event"
                                                                    label-size="sm">
                                                                    <treeselect placeholder="Select event..."
                                                                        v-model="lines.item.eventcode" :clearable="true"
                                                                        :async="true"
                                                                        :load-options="treeselect_loadEvent"
                                                                        searchPromptText="Type at least 4 chars..."
                                                                        :show-count="true"
                                                                        :flatten-search-results="true"
                                                                        :disable-branch-nodes="true" :matchKeys="['id']"
                                                                        search-nested :disabled="readonly">
                                                                        <div slot="value-label" slot-scope="{ node }">
                                                                            {{ node.raw.id }}
                                                                        </div>
                                                                    </treeselect>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Route" label-for="route"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.route"
                                                                            placeholder="Route" size="sm" trim
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.route = ''"
                                                                                :disabled="readonly">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="4" md="3">
                                                                <b-form-group label-cols="12" label="DateTravel"
                                                                    label-size="sm">
                                                                    <b-input-group>
                                                                        <daterangepicker class="w-auto sm" size="sm"
                                                                            ref="travel_at" v-model="mapper_travel_at"
                                                                            :opens="'right'" :locale-data="{
                                                                                direction: 'ltr',
                                                                                format: 'dd/mm/yy',
                                                                                daysOfWeek: [
                                                                                    'Sun',
                                                                                    'Mon',
                                                                                    'Tue',
                                                                                    'Wed',
                                                                                    'Thu',
                                                                                    'Fri',
                                                                                    'Sat',
                                                                                ],
                                                                                monthNames: [
                                                                                    'January',
                                                                                    'February',
                                                                                    'March',
                                                                                    'April',
                                                                                    'May',
                                                                                    'June',
                                                                                    'July',
                                                                                    'August',
                                                                                    'September',
                                                                                    'October',
                                                                                    'November',
                                                                                    'December',
                                                                                ],
                                                                                firstDay: 1,
                                                                                applyLabel: 'OK',
                                                                                cancelLabel: 'Cancel',
                                                                            }" :ranges="false" :showDropdowns="true"
                                                                            :single-date-picker="'single'"
                                                                            :timePicker="false"
                                                                            :timePicker24Hour="false"
                                                                            :time-picker-increment="1">
                                                                        </daterangepicker>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary" @click="mapper_travel_at = {
                                                                                    startDate: null,
                                                                                    endDate: null,
                                                                                }
                                                                                    ">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Qty" label-for="qty"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="number" :min="min_qty"
                                                                            :max="max_qty" v-model="lines.item.qty"
                                                                            placeholder="Qty" size="sm" trim
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.qty = '0'"
                                                                                :disabled="readonly">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Unit Cost ( Ticket )"
                                                                    label-for="lineprice" label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.lineprice"
                                                                            placeholder="Unit Cost ( Ticket )" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.lineprice = '0'">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Unit Taxes" label-for="taxes"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.linetaxes"
                                                                            placeholder="Unit Taxes" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.linetaxes = '0'">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Unit Ex VAT"
                                                                    label-for="linesubtotal" label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.linesubtotal"
                                                                            placeholder="Unit Ex VAT" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.linesubtotal = '0'">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Commission" label-for="comm"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.comm"
                                                                            placeholder="Commission" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.comm = '0'">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Unit VAT" label-for="vat"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.linevat"
                                                                            placeholder="VAT" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.linevat = '0'">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Unit Total" label-for="linetotal"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.linetotal"
                                                                            placeholder="Cost Total" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.linetotal = '0'">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Due" label-for="due"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.linedue"
                                                                            placeholder="Paid" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.due = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Commission Rate" label-for="rate"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.rate"
                                                                            placeholder="Commission Rate" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.rate = '0'">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Cost A/C NL" label-for="due"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.costnl"
                                                                            placeholder="Cost A/C NL" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.costnl = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group id="bspref" label="BSP Ref"
                                                                    label-for="bspref" label-cols="12">
                                                                    <b-input-group>
                                                                        <b-input-group class="treeselect_all"
                                                                            style="left:45px; top:-12px">
                                                                            <i
                                                                                class="fa fa-info-circle text-danger"></i>
                                                                        </b-input-group>
                                                                        <b-tooltip target="bspref" triggers="hover"
                                                                            placement="bottom">Either the BSP
                                                                            ticketno or RFND to mark a
                                                                            refund</b-tooltip>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.bspref" :state="false"
                                                                            placeholder="BSP Ref" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.bspref = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="CreditNo" label-for="refcredit"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.refcredit"
                                                                            placeholder="CreditNo" size="sm"
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.refcredit = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Active?" label-for="active"
                                                                    label-cols="12">
                                                                    <b-form-radio-group id="active"
                                                                        v-model="item.active" :options="[
                                                                            { text: 'Yes', value: 1 },
                                                                            { text: 'No', value: 0 },
                                                                        ]" buttons button-variant="outline-success"
                                                                        size="sm"
                                                                        name="radio-btn-outline"></b-form-radio-group>
                                                                </b-form-group></b-col>

                                                        </b-row>

                                                        <b-row align-v="end"
                                                            class="nopadding my-2 mt-4 background-transparent"
                                                            no-gutters>
                                                            <b-col cols="12"
                                                                class="text-left text-orange mt-n2 divider ">
                                                                MI Fields
                                                            </b-col>
                                                        </b-row>
                                                        <!-- {{ mifields }} -->
                                                        <b-row v-if="mifields.length > 0">
                                                            <b-col cols="12" sm="6" md="4" xl="3"
                                                                v-for="(mifield, index) in mifields" :key="index">
                                                                <!-- <b-form-group :label="label(mifield)" label-cols="12" label-size="sm">-->
                                                                <b-form-group
                                                                    :label="$helpers.requiredlabel(requirement, mifield.label)"
                                                                    :class="$helpers
                                                                        .requiredlabel(requirement, mifield.label)
                                                                        .slice(0, 1) == '*'
                                                                        ? 'text-danger'
                                                                        : ''
                                                                        " label-cols="12" label-size="sm">
                                                                    <b-input-group>
                                                                        <!-- :placeholder="placeholder(mifield)" :debounce="mifields.debounce" -->
                                                                        <!-- v-model="mifields.args[mifield.key]"  -->
                                                                        <b-form-input v-if="mifield.type == 'input'"
                                                                            type="text"
                                                                            :disabled="mifield.active == '0'" size="sm"
                                                                            trim v-model="mifield.value"
                                                                            :placeholder="mifield.label"></b-form-input>

                                                                        <!-- v-if="mifield.clearable" @click="mifields.args[mifield.key] = null"-->
                                                                        <b-input-group-append
                                                                            v-if="mifield.type == 'input'"
                                                                            @click="mifield.value = ''">
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>

                                                                    <!-- && filter.options
                      :multiple="filter.multiple == true ? true : false" -->
                                                                    <!-- v-model="mifield.args[mifield.key]" :placeholder="mifield.placeholder"-->
                                                                    <treeselect v-if="mifield.type == 'listofvalues'"
                                                                        :show-count="true"
                                                                        :flatten-search-results="true"
                                                                        :clearable="false" :disable-branch-nodes="true"
                                                                        :matchKeys="['id']" search-nested
                                                                        :options="mifield.options"
                                                                        v-model="mifield.value">
                                                                    </treeselect>

                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row v-if="mifields.length == 0">
                                                            <b-col>
                                                                There are no fields to display
                                                            </b-col>
                                                        </b-row>
                                                     
                                                        <b-row class="mt-2" v-if="permissionvalid('systems.development')">
                                                            <b-col cols="12">
                                                                <b-form-group label="Tags" label-for="tags"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text" v-model="item.tags"
                                                                            placeholder="Tags" size="sm" trim
                                                                            :disabled="readonly"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="readonly"
                                                                                variant="outline-secondary"
                                                                                @click="item.tags = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>

                                                    </p>

                                                </b-tab>

                                                <b-tab v-if="lines.item.id">
                                                    <template #title>
                                                        <i class="fa fa-history text-primary mr-1"></i>Audit
                                                    </template>
                                                    <p class="py-3 px-0">
                                                        <b-row>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="ID" label-for="id" label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.id" placeholder=""
                                                                            size="sm" :disabled="true"></b-form-input>

                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                        </b-row>
                                                        <b-row>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Entry" label-for="entry"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.entry"
                                                                            placeholder="Entry" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="true"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.entry = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Accounting Period" label-for="ap"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.ap"
                                                                            placeholder="Accounting Period" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="true"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.ap = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Period" label-for="period"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.period"
                                                                            placeholder="Period" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="true"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.period = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Age" label-for="age"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.age" placeholder="Age"
                                                                            size="sm" :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="true"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.age = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Created At" label-for="created_at"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-input-group-prepend>
                                                                            <b-form-datepicker size="sm"
                                                                                v-model="lines.item.created_at"
                                                                                button-only label-help="" locale="en-GB"
                                                                                :disabled="true"></b-form-datepicker>
                                                                        </b-input-group-prepend>
                                                                        <b-form-input size="sm" id="date"
                                                                            v-model="lines.item.created_at" type="text"
                                                                            placeholder="YYYY-MM-DD" autocomplete="off"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.created_at = null"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Created By" label-for="created_by"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.created_by"
                                                                            placeholder="" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.created_by = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Updated At" label-for="updated_at"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-input-group-prepend>
                                                                            <b-form-datepicker size="sm"
                                                                                v-model="lines.item.updated_at"
                                                                                button-only label-help="" locale="en-GB"
                                                                                :disabled="true"></b-form-datepicker>
                                                                        </b-input-group-prepend>
                                                                        <b-form-input size="sm" id="date"
                                                                            v-model="lines.item.updated_at" type="text"
                                                                            placeholder="YYYY-MM-DD" autocomplete="off"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.updated_at = null"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Updated By" label-for="updated_by"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.updated_by"
                                                                            placeholder="" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.updated_by = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>

                                                    </p>
                                                </b-tab>

                                            </b-tabs>
                                        </b-tab>

                                    </b-tabs>
                                </p>

                            </b-tab>

                            <b-tab v-if="remittanceno" @click="remittance_load">
                                <template #title>
                                    <div class="badgecontainer pr-3 mr-1">
                                        <i class="fa fa-link text-orange mr-1"></i>
                                        {{ lines.item.remittanceno }}
                                        <b-badge id="selection" variant="primary" class="edit_tab">
                                            {{ lines.item.remittances }}</b-badge>
                                    </div>
                                </template>
                                <b-row>
                                    <b-col>
                                        <b-alert :show="true" variant="secondary">
                                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                <b-col>
                                                    <span class="h6"> This bank payment/receipt has the following transaction references allocated.
                                                    </span></b-col></b-row>
                                        </b-alert></b-col>
                                </b-row>
                                <b-tabs v-model="tabmatch">

                                    <b-tab :disabled="lines.items == 0">
                                        <template #title>
                                            <div class="badgecontainer pr-2 mr-1">
                                                <i class="fa fa-table text-primary mr-1"></i>
                                                Transactions
                                            </div>
                                        </template>

                                        <p class="px-0">
                                            <b-row>
                                                <b-col>
                                                    <d-table classdivtable="availtable datatable nested "
                                                        refid="segments" :icon="remittance.icon" :selectmode="'single'"
                                                        :busy="remittance.busy" :tools="remittance.tools"
                                                        :badges="remittance.badges" :fields="remittance.fields"
                                                        :selectall="remittance.selectall" :items="remittance.items"
                                                        :limit="remittance.limit" :showpages="true"
                                                        @load="remittance_load" @click="remittance_click"
                                                        @select="remittance_select">
                                                    </d-table>
                                                    <div v-if="component">
                                                        <component :is="component" :selection="remittance.selected"
                                                            :config="cconfig" @discard="remittance_click('discard')"
                                                            @refresh="remittance_click('refresh')">
                                                        </component>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </p>

                                    </b-tab>
                                    <b-tab v-if="1==0">
                                        <template #title>
                                            <div class="badgecontainer pr-3 mr-1">
                                                <i class="fa fa-link text-orange mr-2"></i>
                                                Match
                                                <!-- <b-badge id="selection" variant="primary" class="edit_tab">
                                                    {{ lines.items.length }}</b-badge>
                                                <b-tooltip target="selection" placement="bottom">{{ lines.items.length
                                                    }}
                                                    transaction(s)
                                                    selected</b-tooltip> -->
                                            </div>

                                        </template>
                                        <p>
                                            <b-row>
                                                <b-col>
                                                    <b-alert :show="true" variant="secondary">
                                                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                            <b-col>
                                                                <span class="h6"> Match transactions in the bought
                                                                    ledger,
                                                                    select a list of transactions below
                                                                    to zero the due amount.
                                                                </span></b-col></b-row>
                                                    </b-alert></b-col>
                                            </b-row>
                                            <b-row class="my-2">
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="Supplier BL A/C"
                                                        label-size="sm">
                                                        <treeselect placeholder="Select blac..."
                                                            searchPromptText="Type at least 3 chars..." v-model="blac"
                                                            :clearable="true" :async="true"
                                                            :load-options="treeselect_loadBLAC" :show-count="true"
                                                            :flatten-search-results="true" :disable-branch-nodes="true"
                                                            :matchKeys="['id']" search-nested :disabled="false">
                                                            <div slot="value-label" slot-scope="{ node }">
                                                                {{ node.raw.id }}
                                                            </div>
                                                        </treeselect>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="12" md="12" xl="12">
                                                    <b-form-group
                                                        :label="byid_visible ? 'Transaction UID ( Paste List ), Count [ ' + id.length + ' ]' : 'Transaction Ref' + ' ( Paste List ), Count [ ' + referenceno.length + ' ]'"
                                                        label-for="referenceno" label-cols="12">
                                                        <b-input-group
                                                            class="treeselect_all justify-content-end pr-2px">
                                                            <i style="padding-top: 0.7em"
                                                                class="fa fa-info-circle text-black pr-1"
                                                                id="byid-tooltip"></i>
                                                            <span style="padding-top: 0.3em" class="text-primary">By
                                                                UID</span>
                                                            <b-form-checkbox id="byid" v-model="byid_visible"
                                                                class="z-0">
                                                            </b-form-checkbox>
                                                            <b-tooltip target="byid-tooltip" triggers="hover"
                                                                placement="top">Switch to use Unique
                                                                ID charges</b-tooltip>
                                                        </b-input-group>
                                                        <b-input-group v-if="!byid_visible" class="z-0">
                                                            <b-form-tags input-id="reflist" v-model="referenceno"
                                                                tag-variant="primary" separator=" ,;"
                                                                placeholder="Paste Ref (IV519826,CV519827,...)"
                                                                size="sm" class="h-29" add-button-text="+" add-on-change
                                                                remove-on-delete duplicate-tag-text=""
                                                                add-button-variant="outline-primary"></b-form-tags>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="referenceno = []">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                        <b-input-group v-if="byid_visible" class="z-0">
                                                            <b-form-tags input-id="reflist" v-model="id"
                                                                tag-variant="primary" separator=" ,;"
                                                                placeholder="Paste IDs (1976851,1976852,...)" size="sm"
                                                                class="h-29" add-button-text="+" add-on-change
                                                                remove-on-delete duplicate-tag-text=""
                                                                add-button-variant="outline-primary"></b-form-tags>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="id = []">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row class="mt-2" v-if="item.message">
                                                <b-col>
                                                    <b-alert :show="true" :variant="item.error ? 'danger' : 'success'">
                                                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                            <b-col>
                                                                <span class="h6">
                                                                    {{ item.message }}
                                                                </span>
                                                            </b-col>
                                                        </b-row>
                                                    </b-alert>
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="TransactionNo" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.transactionno"
                                                                :debounce="lines.debounce" placeholder="(auto)"
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="item.transactionno = ''" :disabled="true">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6">
                                                    <b-form-group label-cols="12" label="Your Ref" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.yourref"
                                                                :debounce="lines.debounce" placeholder="Your Ref"
                                                                :disabled="item.error || postit_disabled"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="item.yourref = ''"
                                                                    :disabled="item.error || postit_disabled">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </p>
                                        <b-row class="mt-2">
                                            <b-col class="text-left" cols="auto">
                                                <b-button v-if="item.error" squared size="sm" variant="warning"
                                                    @click="matches_load(0)"
                                                    :disabled="referenceno.length == 0 && id.length == 0">
                                                    <i class="fa fa-check"></i>
                                                    Check It
                                                </b-button>

                                                <b-button v-if="!item.error" squared size="sm" variant="primary"
                                                    @click="matches_save" :disabled="postit_disabled">
                                                    <i class="fa fa-check"></i>
                                                    Post It
                                                </b-button>
                                            </b-col>

                                            <b-col class="text-left ml-2 mt-1">
                                                <div v-if="busy">
                                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                                </div>
                                                <div v-else>
                                                    <span v-html="message"></span>
                                                </div>
                                            </b-col>
                                        </b-row>

                                    </b-tab>

                                </b-tabs>


                            </b-tab>



                            <b-tab>
                                <template #title>
                                    <i class="fa fa-comments-o text-primary mr-1"></i>
                                    Notes</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Notes (applied to all)" label-for="notes"
                                                label-cols="12">
                                                <b-form-textarea id="data" v-model="notes" placeholder="Enter notes"
                                                    rows="6" class="smalltextarea" :disabled="user.permissions.includes('boughtledger.save')
                                                        ? false
                                                        : true
                                                        "></b-form-textarea>
                                            </b-form-group> </b-col></b-row>

                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-wpforms text-info mr-1"></i>Invoice
                                </template>
                                <div class="etr">
                                    <b-row>
                                        <b-col cols="12">
                                            <r-invoice :invoiceno="invoiceno" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>

                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left mr-4">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="!readonly && !(tabindex == 1 && remittanceno)">
                                    <i class="fa fa-check"></i>
                                    Post It
                                </b-button>
                            </b-col>
                            <b-col class="text-leftml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row>

                        </b-row>
                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "BLItemEdit",
    async mounted() {

    },
    data() {
        return {
            busy: false,
            message: "",
            tabindex: 0,
            tabmatch: 0,
            blac: null,
            byid_visible: false,
            referenceno: [],
            id: [],
            postit_disabled: true,

            notes: "",
            remittanceno: "",
            eventcode: "",
            slac: "",
            to: "",
            yourref: "",
            invoiceno: "",
            date_at: "",
            paid: "",
            due: "",
            mapper_date_at: {
                startDate: this.$moment().format("YYYY-MM-DD HH:mm"),
                endDate: this.$moment().format("YYYY-MM-DD HH:mm"),
            },
            mapper_travel_at: {
                startDate: null,
                endDate: null,
            },
            item: {
                invoiceno: "*new",
                prefix: "IG",
                active: 1,

                message: "",
                error: true,
                transactiono: "",
                yourref: ""

            },

            lines: {
                title: "Lines",
                icon: "fa fa-list text-info",
                debounce: 500,
                busy: false,
                tools: "go,export,clipboard,clone,deleteconfirm",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                    },
                    {
                        key: "travel_at",
                        label: "DateTravel",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment.unix(value * .001).utc(true).format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "ticketno",
                        label: "TicketNo",
                        sortable: true,
                    },
                     {
                        key: "tickettype",
                        label: "TicketType",
                        sortable: true,
                    },
                    {
                        key: "passenger",
                        label: "Passenger",
                        sortable: true,
                        class: "text-right",
                    },

                    {
                        key: "route",
                        label: "Route",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "qty",
                        label: "Qty",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "lineprice",
                        label: "Unit Cost",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linetaxes",
                        label: "Unit Taxes",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    // {
                    //     key: "linesubtotal",
                    //     label: "Subtotal Cost Ex Vat",
                    //     sortable: true,
                    //     class: "text-right",
                    //     total: 0,
                    //     totalled: true,
                    // },
                    {
                        key: "comm",
                        label: "Comm",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linevat",
                        label: "Unit VAT",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linetotal",
                        label: "Unit Total",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                    },

                ],
                badges: [],
                item: {},
                items: [],
                selected: []
            },
            remittance: {
                title: "Remittance",
                icon: "fa fa-link text-orange",
                debounce: 500,
                busy: false,
                selectall: false,
                limit: 100,
                tools: "go,export,clipboard,undo",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    {
                        key: "invoice_at",
                        label: "InvoiceDate",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-right w-80px",
                    },

                    {
                        key: "creditno",
                        label: "CreditNo",
                        sortable: true,
                        class: "text-right w-80px",
                    },
                    {
                        key: "yourref",
                        label: "Your Ref/PO",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "travel_at",
                        label: "DateTravel",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "paid",
                        label: "Paid",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "uid",
                        label: "UID",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            return "BOP"
                        }
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right",
                        // formatter: (value, key, item) => {
                        //     let result = "";
                        //     if (value) {
                        //         result = this.$moment
                        //             .unix(value / 1000)
                        //             .format("DD/MM/YYYY HH:mm");
                        //     }
                        //     return result;
                        // },
                    },

                    // {
                    //     key: "actions",
                    //     label: "Actions",
                    //     class: "actions w-100px w-sm-100pct",
                    // },
                ],
                badges: [
                    {
                        key: "credit",
                        type: "badge",
                        Credit: "danger",
                        Invoice: "primary",
                        formatter: (value, key, item) => {
                            if (value == true) {
                                return "Credit";
                            } else {
                                return "Invoice";
                            }
                        },
                    },
                ],
                item: {},
                items: [],
                selected: [],
                yourref: "",
                paid: 0,
            },
            matches: {
                debounce: 500,
                badges: [],
                item: {},
                items: [],
                selected: []
            },
        };
    },
    computed: {
        readonly() {
            if (this.user.permissions.includes('boughtledger.admin')) {
                return false;
            }
            if (this.user.permissions.includes('boughtledger.save')) {
                return false
            }
            return true;
        },
        min_qty() {
            if (this.lines.item) {
                if (this.lines.item.qty <= 0) {
                    return 1000 * Math.sign(this.lines.item.qty)
                } else {
                    return 1 * Math.sign(this.lines.item.qty)
                }
            } else {
                return 0
            }
        },
        max_qty() {
            if (this.lines.item) {
                if (this.lines.item.qty <= 0) {
                    return 1 * Math.sign(this.lines.item.qty)
                } else {
                    return 1000 * Math.sign(this.lines.item.qty)
                }
            } else {
                return 0
            }
        }
    },
    watch: {
        mapper_date_at: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.lines.item.date_at = this.$moment(newVal.startDate).valueOf().toString()
                }
            }
        },
        mapper_travel_at: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.lines.item.travel_at = this.$moment(newVal.startDate).valueOf().toString()
                }
            }
        },
        "lines.item.qty": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:lines.item.qty", parseFloat(newVal));
                if (newVal) {
                    if (Math.sign(newVal) == Math.sign(oldVal)) {
                        let sgn = Math.sign(parseFloat(newVal))
                        let qty = Math.abs(parseFloat(newVal))
                        let tax = Math.abs(parseFloat(this.lines.item.linetaxes))
                        let prc = Math.abs(parseFloat(this.lines.item.lineprice))
                        this.lines.item.linesubtotal = (sgn * (qty * (prc + tax))).toFixed(2)
                        this.message = ""
                    } else {
                        let msg = ""
                        if (parseFloat(this.lines.item.qty) > 0) {
                            msg = "Credits MUST have -ve qty!"
                        } else {
                            msg = "Invoices MUST have +ve qty!"

                        }
                        this.message = "<span class='text-danger'>" + msg + "</span>"
                    }
                }
            },
        },
        "lines.item.lineprice": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:lines.item.lineprice", newVal);
                if (newVal) {
                    let sgn = Math.sign(parseFloat(this.lines.item.qty))
                    let qty = Math.abs(parseFloat(this.lines.item.qty))
                    let tax = Math.abs(parseFloat(this.lines.item.linetaxes))
                    let prc = Math.abs(parseFloat(newVal))
                    this.lines.item.linesubtotal = (sgn * (qty * (prc + tax))).toFixed(2)
                }
            },
        },
        "lines.item.linetaxes": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:lines.item.linetaxes", newVal);
                if (newVal) {
                    let sgn = Math.sign(parseFloat(this.lines.item.qty))
                    let qty = Math.abs(parseFloat(this.lines.item.qty))
                    let tax = Math.abs(parseFloat(newVal))
                    let prc = Math.abs(parseFloat(this.lines.item.lineprice))
                    this.lines.item.linesubtotal = (sgn * (qty * (prc + tax))).toFixed(2)
                }
            },
        },
        "lines.item.linesubtotal": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:lines.item.linesubtotal", newVal);
                if (newVal) {
                    let sgn = Math.sign(parseFloat(this.lines.item.qty))
                    let sub = Math.abs(parseFloat(newVal))
                    let com = Math.abs(parseFloat(this.lines.item.linevat))
                    let vat = Math.abs(parseFloat(this.lines.item.linevat))
                    this.lines.item.linetotal = (sgn * (sub + vat)).toFixed(2)
                    if (this.lines.item.linedue != 0) {
                        this.lines.item.linedue = this.lines.item.linetotal
                    }
                }
            },
        },
        "lines.item.linevat": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:lines.item.linevat", newVal);
                if (newVal) {
                    let sgn = Math.sign(parseFloat(this.lines.item.qty))
                    let sub = Math.abs(parseFloat(this.lines.item.linesubtotal))
                    let com = parseFloat(this.lines.item.comm)
                    let vat = Math.abs(parseFloat(newVal))
                    this.lines.item.linetotal = (sgn * (sub + com + vat)).toFixed(2)
                    if (this.lines.item.linedue != 0) {
                        this.lines.item.linedue = this.lines.item.linetotal
                    }
                }
            },
        },
        "lines.item.comm": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:lines.item.comm", newVal);
                if (newVal) {
                    let sgn = Math.sign(parseFloat(this.lines.item.qty))
                    let sub = Math.abs(parseFloat(this.lines.item.linesubtotal))
                    let com = parseFloat(newVal)
                    let vat = Math.abs(parseFloat(this.lines.item.linevat))
                    this.lines.item.linetotal = (sgn * (sub + com + vat)).toFixed(2)
                    if (this.lines.item.linedue != 0) {
                        this.lines.item.linedue = this.lines.item.linetotal
                    }
                }
            },
        },
        "lines.item.linetotal": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                if (newVal == 0) {
                    this.lines.item.lineprice = "0.00"
                    this.lines.item.linetaxes = "0.00"
                    this.lines.item.linedue = "0.00"
                }
                console.log("watch:lines.item.linetotal", newVal);
                if (parseFloat(oldVal) == parseFloat(this.lines.item.linedue)) {
                    this.lines.item.linedue = this.lines.item.linetotal
                }
            },
        },
        "item.slac": {
            // deep: true,
            // immediate: true,
            async handler(newVal, oldVal) {
                console.log("watch:item.slac", newVal);
                let attributes = await this.$helpers.loadSLACAttributes(newVal);
                await this.load_mifields("true");
            },
        },
        referenceno: {
            async handler(newVal, oldVal) {
                this.matches.items = []
                this.item.yourref = ""
                this.item.message = ""
                this.item.error = true
                this.postit_disabled = true
            }
        },
        id: {
            async handler(newVal, oldVal) {
                this.matches.items = []
                this.item.yourref = ""
                this.item.message = ""
                this.item.error = true
                this.postit_disabled = true
            }
        },
    },
    methods: {
        async load() {
            await this.lines_load();
        },
        async lines_load(offset, limit, page) {

            if (page) {
                this.lines.page = page
            }

            this.lines.busy = true;
            this.lines.items = [];

            let requirements = "";
            for (var prop in this.requirement) {
                if (prop.slice(0, 3) != 'mi_') {
                    if (rows[0][prop] == null) {
                        requirements += this.requirement[prop] + ",";
                        break;
                    }
                }
            }
            requirements += await this.mifields_requirement()

            if (requirements.length > 0) {
                this.message =
                    "<span class='text-danger'>" +
                    requirements.slice(0, -1) +
                    " required field(s). </span>";
                this.busy = false;
                return;
            } else {
                this.message = ""
            }

            if (this.mifields.length > 0) {
                let tags = JSON.parse(this.item.tags || "{}");
                for (var k = 0; k < this.mifields.length; k++) {
                    tags[this.mifields[k].key] = this.mifields[k].value;
                }
                rows[0].tags = JSON.stringify(tags);
            }

            let variables = {
                id: this.selection.map(q => q.id).join(","),
                mssql: true,
            };
            console.log("variables", variables);

            // this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query BLTransactions(  
                $mssql: Boolean
                $offset: Int
                $limit: Int            
                $id: String
                $entry: String) {
                BLTransactions( 
                    mssql: $mssql
                    offset: $offset
                    limit: $limit
                    id: $id
                    entry: $entry) {
                    id
                    lines
                    counter
                    entry
                    date_at
                    invoiceno
                    remittanceno
                    remittances
                    ticketno
                    tickettype
                    line
                    qty
                    lineprice
                    linetaxes
                    linesubtotal
                    linevat
                    linetotal
                    linedue
                    comm
                    rate
                    route
                    moreinfo
                    airline
                    conjline
                    blac
                    typeref
                    typeinv
                    bltype
                    bspref
                    refcredit
                    passenger
                    travel_at
                    route
                    credit
                    vatcode
                    notes
                    slac
                    yourref
                    to
                    age
                    salesgroup
                    eventcode
                    ap
                    period
                    costnl
                     active
                     tags
                    controlac           
                    created_at
                    created_by
                    updated_at
                    updated_by
                }
              }
            `,
                    variables,
                });

                this.lines.items = response.data.BLTransactions

                if (this.lines.items.length > 0) {
                    this.invoiceno = this.lines.items[0].invoiceno
                    this.eventcode = this.lines.items[0].eventcode
                    this.slac = this.lines.items[0].slac
                    this.to = this.lines.items[0].to
                    this.yourref = this.lines.items[0].yourref

                    this.paid = this.lines.items[0].linetotal
                    this.due = this.lines.items[0].linedue

                    let startDate = this.$moment.unix(this.lines.items[0].date_at * 0.001).utc(true).format("YYYY-MM-DD HH:mm")
                    let endDate = startDate
                    this.mapper_date_at = { startDate, endDate }

                    if (this.lines.items[0].travel_at) {
                        startDate = this.$moment.unix(this.lines.items[0].travel_at * 0.001).utc(true).format("YYYY-MM-DD")
                        endDate = startDate
                        this.mapper_travel_at = { startDate, endDate }
                    }
                }

            } catch (error) {
                console.log(error);
            }

            this.lines.busy = false;
        },

        async lines_click(a, ss) {
            console.log("lines_click", a, ss);

            let state = this.lines;

            switch (a) {

                case "go":
                    this.component = null;
                    await this.lines_load();
                    break;

                case "clone":
                    if (state.item) {
                        let copy = { ...state.item, id: "__copy", line: (this.lines.items.length + 1).toString() }
                        delete copy.ticketno
                        this.lines.items.push(copy)
                    }
                    break;
                case "save":
                    await this.lines_saveit()
                    break;

            }
        },
        async lines_select(ss, tools) {
            console.log("lines_select", ss);

            let state = this.lines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export", "clipboard",];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "clone", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = { ...state.selected[0] }; // WHAT YOU SELECTED

                if (state.item.linedue == 'NaN') {
                    state.item.linedue = state.item.linetotal
                }

                this.notes = state.item.notes
                this.remittanceno = state.item.remittanceno

                this.item.slac = state.item.slac
                this.item.tags = state.item.tags
                await this.load_mifields("true");

            } else {
                state.item = {}

                this.notes = null
                this.remittanceno = null
            }
        },
        async lines_total(f) {
            console.log('lines_total', f)
            let found = f.find(o => o.key == 'amount')
            if (found) {
                this.total = found.total
            }

        },

        async lines_save(ss) {
            this.lines.busy = true;

            let variables = {
                rows: this.cleanit(ss),
            };

            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation BL_save($rows: [BLTransaction_input]) {
                        BL_save(rows: $rows) {
                        id
                        }
                    }
                    `,
                    variables,
                });


                this.message = "<span class='text-primary'>Saved it.</span>";
                this.lines.busy = false;


            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

        },

        async remittance_load(offset, limit, page) {

            if (page) {
                this.remittance.page = page
            }

            this.remittance.busy = true;
            this.remittance.items = [];

            let variables = {
                invoiceno: this.lines.item.invoiceno,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                            query BLTransactions($invoiceno: String) {
                                BLTransactions(invoiceno: $invoiceno) {
                                invoiceno                          
                                remittance {
                                    uid
                                    invoiceno
                                    invoice_at
                                    creditno
                                    yourref
                                    slac
                                    eventcode
                                    travel_at
                                    paid: valuecleared
                                    updated_at
                                }
                            }
                        }
                    `,
                    variables,
                });

                if (response.data.BLTransactions[0].remittance) {

                    // this.item = response.data.SLTransactions[0].remittance
                    // this.item.date = this.$moment.unix(this.item.date * 0.001).utc(false).format("YYYY-MM-DD");

                    this.remittance.items = response.data.BLTransactions[0].remittance
                    if (this.remittance.items.length > 0) {
                        this.remittance.paid = this.remittance.items[0].paid
                        this.remittance.yourref = this.remittance.items[0].yourref
                    }

                } else {

                    // this.item.invoiceno = "PP<new>"
                    // this.item.date = this.$moment().format("YYYY-MM-DD")
                    // this.item.slac = this.selection[0].slac
                    // this.item.yourref = "BACS " + this.$moment().format("DD.MM.YY")
                    // this.remittance.items = this.selection

                }

            } catch (error) {
                console.log(error);
            }
            this.remittance.busy = false;
        },


        async remittance_click(a, ss) {
            console.log("remittance_click", a, ss);

            let state = this.remittance;

            switch (a) {
                case "selectall":
                    this.remittance.selectall = !this.remittance.selectall
                    break;
                case "go":
                    this.component = null;
                    await this.remittance_load();
                    break;

                case "save":
                    await this.remittance_saveit()
                    break;

                case "undo":
                    await this.remittance_undoit()
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;

            }
        },
        async remittance_select(ss, tools) {
            console.log("remittance_select", ss);

            let state = this.remittance;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export", "clipboard", "undo"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            this.credited = 0
            if (state.selected.length > 0) {
                let value = 0
                state.selected.forEach(function (action, index) {
                    value += parseFloat(state.selected[index].saletotal)
                })
                this.credited = value
            } else {
                state.item = {}
            }
        },


        async saveit() {

            let ss = []
            if (this.lines.item.id) {
                ss = [{ ...this.lines.item, tags: this.item.tags }]
            } else {
                for (var i = 0; i < this.selection.length; ++i) {
                    ss.push({ id: this.selection[i].id, slac: this.slac, eventcode: this.eventcode, tags: this.item.tags, notes: this.notes });
                }
            }

            await this.lines_save(ss)
        },

        async remittance_undoit() {
            console.log('remittance_undoit')
        },

        async matches_load(offset, limit, page) {

            this.busy = true
            if (page) {
                this.matches.page = page
            }

            this.matches.busy = true;

            let variables = {
                blac: this.blac,
                referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
                id: this.id.length > 0 ? this.id.join(",") : null,
                action: "match"
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query BL_matches($blac: String, $referenceno: String, $id:String, $action: String) {
                            BL_matches(blac: $blac, referenceno: $referenceno, id: $id, action: $action) {
                                message
                                error
                                transactionno
                                yourref
                                remittances {
                                    counter
                                    entry
                                    blac
                                    referenceno
                                    ticketno
                                    slac
                                    eventcode
                                    amount
                                    due
                                    pay
                                }
                            }
                        }
                    `,
                    variables,
                });

                this.item = response.data.BL_matches
                this.matches.items = this.item.remittances
                this.postit_disabled = this.item.error

            } catch (error) {
                console.log(error);
            }

            this.matches.busy = false;
            this.busy = false
        },
        async matches_click(a, ss) {
            console.log("matches_click", a, ss);

            let state = this.matches;

            switch (a) {
                case "selectall":
                    this.matches.selectall = !this.matches.selectall;
                    break;
                case "go":
                    this.component = null;
                    await this.matches_load();
                    break;

                case "save":
                    await this.matches_saveit()
                    break;

            }
        },
        async matches_select(ss, tools) {
            console.log("matches_select", ss);

            let state = this.matches;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = { ...state.selected[0] }  // WHAT YOU SELECTED
                state.item.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")
                state.item.ticketno = state.item.ticketno.split(',')
            } else {
                state.item = {}
            }
        },
        async matches_save() {

            this.busy = true

            let variables = {
                blac: this.blac,
                referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
                id: this.id.length > 0 ? this.id.join(",") : null,
                yourref: this.item.yourref ? this.item.yourref : null,
                action: "match",
                remittances: this.cleanit(this.matches.items),
                apply: true
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query BL_matches($blac: String, $referenceno: String, $id:String, $yourref:String, $action:String, $remittances:[BL_remittances_input], $apply:Boolean) {
                            BL_matches(blac: $blac, referenceno: $referenceno, id: $id, yourref:$yourref, action:$action, remittances:$remittances, apply:$apply ) {
                                message
                                error
                                transactionno
                                yourref	
                                remittances {
                                    counter
                                    entry
                                    blac
                                    referenceno
                                    ticketno
                                    slac
                                    eventcode
                                    amount
                                    due
                                    pay
                                }
                            }
                        }
                    `,
                    variables,
                });

                this.item = response.data.BL_matches
                this.matches.items = this.item.remittances

                this.postit_disabled = true

            } catch (error) {
                console.log(error);
            }

            this.busy = false
        },

    },
};
</script>